/** Layout Spacer. */
export const LAYOUT_SPACER = {
  REM: ['0rem', '0.25rem', '0.5rem', '1rem', '1.5rem', '3rem'],
  PX: [0, 4, 8, 16, 24, 48],
} as const;

/** Layout Width. */
export const LAYOUT_WIDTH = {
  XXXS: 80,
  XXS: 160,
  XS: 320,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400,
  XXXL: 1600,
} as const;

/** Layout Height. */
export const LAYOUT_HEIGHT = {
  XXXS: 40,
  XXS: 80,
  XS: 160,
  SM: 300,
  MD: 440,
  LG: 580,
  XL: 720,
  XXL: 860,
  XXXL: 940,
} as const;

/** Z-index. */
export const Z_INDEX = {
  OVERLAY: 10001,
  MAX: 999999999,
};

/** Component size. */
export const COMPONENT_SIZE = {
  INPUT: {
    LABEL: 20.39,
    HEIGHT: 34.39,
  },
  LIST_CONTENT: {
    ITEM: 28.29,
    MAX_HEIGHT: 200,
  },
  LOADING_TEXT: 26.5,
} as const;

/** Grid size. */
export const GRID_SIZE = {
  TOOLBAR_HEIGHT: 40 + 2 * LAYOUT_SPACER.PX[2],
  HEADER_HEIGHT: 36 + 2 * LAYOUT_SPACER.PX[2],
  ROW_HEIGHT: 32 + 2 * LAYOUT_SPACER.PX[2],
  COLUMN_WIDTH: {
    CHECKBOX: 50,
    SM: 180,
    MD: 320,
  },
} as const;
